import { BehaviorSubject } from 'rxjs';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ProductListSnackbarService {
  private readonly snackbarMessage = new BehaviorSubject<string>('');

  readonly snackbar$ = this.snackbarMessage.asObservable();

  openSnackbar(message: string): void {
    this.snackbarMessage.next(message);
  }
}
